/* ограничение длины слов, где разные слова разделяются пробелами */
export const cutByLength =
    (maxLength: number) =>
    (value: string): string =>
        value.replace(new RegExp(`(\\S{${maxLength}})\\S*(\\s?)`, 'g'), '$1$2');
